import apiService from '../ApiService';
import axiosInstance from '../axiosInstance';

const endpoint = '/application';

export const getApplication = async (params = {}) => {
    try {
        const response = await apiService.get(endpoint, { params });
        return response;
    } catch (error) {
        console.error('Error fetching application data:', error);
        throw error;
    }
};

export const getApplicationById = async (id) => {
    try {
        const response = await apiService.getById(endpoint, id);
        return response;
    } catch (error) {
        console.error(`Error fetching application with ID ${id}:`, error);
        throw error;
    }
};

export const createApplication = async (applicationData) => {
    try {
        const response = await apiService.create('application', applicationData);
        return response;
    } catch (error) {
        console.error('Error creating application:', error);
        throw error;
    }
};

export const updateApplication = async (id, data) => {
    try {
        const response = await apiService.update(endpoint, id, data);
        return response;
    } catch (error) {
        console.error('Error upadte application:', error);
        throw error;
    }
};


export const getExport = async () => {
    try {
        const response = await axiosInstance.get("/export/excel", {
            responseType: "blob"
        });

        let filename = "applications.xlsx";
        const contentDisposition = response.headers["content-disposition"];

        if (contentDisposition) {
            const utf8Match = contentDisposition.match(/filename\*\=UTF-8''(.+)/);

            if (utf8Match && utf8Match[1]) {
                filename = decodeURIComponent(utf8Match[1]);
            } else {
                const asciiMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (asciiMatch && asciiMatch[1]) {
                    filename = asciiMatch[1];
                }
            }
        }

        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);

        return {
            success: true,
            filename
        };
    } catch (error) {
        console.error("Excel export failed:", error);
        throw error;
    }
};



